export type VariantTypes =
	| "primary"
	| "gray"
	| "white"
	| "transparent"
	| "dark"
	| "orange"
	| "orange-outline"
	| "blueDark"
	| "primary-outline"
	| "dark-outline"
	| "facebook"
	| "facebook-outline"
	| "sand"
	| "green"
	| "red";

const colors = {
	primary: "white",
	gray: "dark",
	white: "dark",
	transparent: "dark dark:text-white",
	dark: "white",
	orange: "white",
	blueDark: "white",
	facebook: "white",
	sand: "dark",
	green: "white",
	red: "white",
} as any;

type VariantOptions = {
	square?: boolean;
	noBorder?: boolean;
};

function useVariant(
	variant: VariantTypes = "primary",
	options?: VariantOptions
) {
	const classes = [] as string[];

	if (!variant.includes("outline")) {
		classes.push(`text-${colors[variant]}`);
		if (variant === "orange") {
			// classes.push(
			// 	"bg-gradient-to-br from-orange-dark to-orange-light border-transparent"
			// );
			// if (!options?.noBorder) {
			// 	if (options?.square) {
			// 		classes.push(`border-2 border-transparent`);
			// 	} else {
			// 		classes.push(`border-2 border-transparent`);
			// 	}
			// }
		} else {
			classes.push(`bg-${variant}`);
			// if (!options?.noBorder) {
			// 	classes.push(`border-2 border-${variant}`);
			// }
		}
	} else {
		let extractedVariant = variant.replace("-outline", "");
		extractedVariant = variant.replace("-outlined", "");
		extractedVariant = variant.replace("outlined", "");
		if (!extractedVariant) extractedVariant = "dark";

		classes.push(`text-${extractedVariant}`);
		if (!options?.noBorder) {
			classes.push(`border-${extractedVariant}`);
			classes.push(`border-2`);
		}
	}

	return classes.join(" ");
}

export default useVariant;
